import { useCallback, useMemo } from 'react';

import { useMicroMarketCacheStore } from '@/feature/event-details-sbk/hooks/use-micro-market-cache';
import { MarketCategoryType } from '@/feature/event-details-sbk/types';
import { isSupplierForProduct } from '@/feature/event-details-sbk/utils/is-supplier-for-product';
import { useIsPredictionsProduct } from '@/hooks/use-is-predictions-product';
import { useSubscribePublic } from '@/utils/websocket/hooks';
import { NewMarketMessage } from '@/utils/websocket/types';

export const useSubscribeEventNewMarket = (
    eventId: string,
    marketGroupId: string,
    marketCategoryType: MarketCategoryType,
    enabled?: boolean
) => {
    const { actions } = useMicroMarketCacheStore();
    const isPredictions = useIsPredictionsProduct();
    const handleNewMarket = useCallback(
        (message: NewMarketMessage) => {
            if (!isSupplierForProduct(message.supplier, isPredictions)) {
                return;
            }
            actions.handleNewMarket(message, marketCategoryType);
        },
        [actions, marketCategoryType, isPredictions]
    );
    const params = useMemo(() => ({ eventId, marketGroupId }), [eventId, marketGroupId]);
    useSubscribePublic<'eventNewMarket'>(
        'event:{eventId}:marketGroup:{marketGroupId}',
        params,
        'new_market',
        handleNewMarket,
        enabled
    );
};
